import routes from '@modules/payment-option/payment-option-routes';
import store from '@modules/payment-option/payment-option-store';

export default {
  routes,
  store,
};
